import './main.js'
import React from 'react'
import Header from '../react/components/Header.js'
import HeroCarousel from '../react/components/HeroCarousel/index.js'
import BookingWidget from '../react/components/BookingWidget/index.js'
import SwiperComponent from '../react/components/SwiperHome/index.js'
import ImportantNoticesDropdown from '../react/components/Notices/index.js'
import Cars from '../react/components/Cars/index.js'
import Newsletter from '../react/components/Newsletter.js'
import Booking from '../react/components/Booking'
import BookingConfirmation from '../react/components/Booking/BookingConfirmation'
import CheckInModal from '../react/components/Modals/CheckInModal.js'

import 'antd/dist/reset.css'
import { createRoot } from 'react-dom/client'
import Fleet from '../react/components/Fleet/index.js'
import ModifySearch from '../react/components/ModifySearch/index.js'
import { Provider } from 'react-redux'
import store, { persistor } from './lib/redux/store.js'
import { PersistGate } from 'redux-persist/integration/react'
import Modify from '../react/components/Modify/index.js'

import InpathIndex from '../react/components/Inpath/index.js'
import InLine from '../react/components/InLine/index.js'
import AppTabs from '../react/components/AppTabs/index.js'
import MobileApp from '../react/components/MobileApp/index.js'
import BookingConfirmationFooter from '../react/components/Booking/BookingConfirmationFooter.js'

// create with ReactDOM.createRoot instead of using depcrated render

if (document.getElementById('header')) {
  const header = createRoot(document.getElementById('header'))
  header.render(<Header />)
}

if (document.getElementById('hero-carousel')) {
  const heroCarousel = createRoot(document.getElementById('hero-carousel'))
  heroCarousel.render(<HeroCarousel />)
}

if (document.getElementById('swiper')) {
  const rootSwiper = createRoot(document.getElementById('swiper'))
  rootSwiper.render(<SwiperComponent />)
}

if (document.getElementById('booking-bar')) {
  const booking = createRoot(document.getElementById('booking-bar'))

  booking.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BookingWidget sticky />
      </PersistGate>
    </Provider>
  )
}

if (document.getElementById('app-tabs')) {
  const appTabs = createRoot(document.getElementById('app-tabs'))
  appTabs.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppTabs />
      </PersistGate>
    </Provider>
  )
}

if (document.getElementById('important-notices')) {
  const notices = createRoot(document.getElementById('important-notices'))
  notices.render(<ImportantNoticesDropdown />)
}

if (document.getElementById('cars')) {
  const cars = createRoot(document.getElementById('cars'))
  cars.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Cars />
      </PersistGate>
    </Provider>
  )
}

if (document.getElementById('newsletter')) {
  const newsletter = createRoot(document.getElementById('newsletter'))
  newsletter.render(<Newsletter />)
}

if (document.getElementById('booking-app')) {
  const bookingApp = createRoot(document.getElementById('booking-app'))
  bookingApp.render(<Booking />)
}

if (document.getElementById('booking-confirmation-app')) {
  const bookingConfirmationApp = createRoot(
    document.getElementById('booking-confirmation-app')
  )
  bookingConfirmationApp.render(<BookingConfirmation />)
}

if (document.getElementById('modalCheckIn')) {
  const checkInModal = createRoot(document.getElementById('modalCheckIn'))
  checkInModal.render(<CheckInModal />)
}

if (document.getElementById('fleet-app')) {
  const fleetApp = createRoot(document.getElementById('fleet-app'))
  fleetApp.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Fleet />
      </PersistGate>
    </Provider>
  )
}

if (document.getElementById('modify-search')) {
  const modifySearch = createRoot(document.getElementById('modify-search'))
  modifySearch.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ModifySearch />
      </PersistGate>
    </Provider>
  )
}

if (document.getElementById('modify-app')) {
  const modifyApp = createRoot(document.getElementById('modify-app'))
  modifyApp.render(<Modify />)
}

if (document.getElementById('inpath-index-app')) {
  const inpathIndexApp = createRoot(document.getElementById('inpath-index-app'))
  inpathIndexApp.render(<InpathIndex />)
}

if (document.getElementById('inline-app')) {
  const inLineApp = createRoot(document.getElementById('inline-app'))
  inLineApp.render(<InLine />)
}

if (document.getElementById('mobile-app')) {
  const mobileApp = createRoot(document.getElementById('mobile-app'))
  mobileApp.render(<MobileApp />)
}

if (document.getElementById('booking-confirmation-footer-app')) {
  const bookingConfirmationFooter = createRoot(
    document.getElementById('booking-confirmation-footer-app')
  )
  bookingConfirmationFooter.render(<BookingConfirmationFooter />)
}
